import { Separator } from '@/components/ui/separator';

import { BundleSection } from './BundleSection';
import { ContextVariablesSection } from './ContextVariablesSection';
import { TagsSection } from './TagsSection';

/** Test-mode Context tab — editable test-session context. */
export const ContextPanelTest = () => (
  <div className="flex flex-1 flex-col items-start gap-6 self-stretch">
    <BundleSection />
    <Separator />
    <ContextVariablesSection />
    <Separator />
    <TagsSection />
  </div>
);
